import { type TokenGroup } from "../../types";
import { altitude } from "../globals/altitude";
import { amber } from "../globals/amber";
import { cyan } from "../globals/cyan";
import { flash } from "../globals/flash";
import { grass } from "../globals/grass";
import { gray } from "../globals/gray";
import { white } from "../globals/white";

export const text = {
  name: "text",
  variables: {
    accent: {
      type: "color",
      value: {
        dark: altitude.variables["11"].value.dark,
        light: altitude.variables["11"].value.light,
      },
    },
    disabled: {
      type: "color",
      value: {
        dark: gray.variables["8"].value.dark,
        light: gray.variables["8"].value.light,
      },
    },
    error: {
      type: "color",
      value: {
        dark: flash.variables["11"].value.dark,
        light: flash.variables["11"].value.light,
      },
    },
    inverse: {
      type: "color",
      value: {
        dark: white.variables.default.value.dark,
        light: white.variables.default.value.light,
      },
    },
    metadata: {
      type: "color",
      value: {
        dark: gray.variables["9"].value.dark,
        light: gray.variables["9"].value.light,
      },
    },
    placeholder: {
      type: "color",
      value: {
        dark: gray.variables["7"].value.dark,
        light: gray.variables["7"].value.light,
      },
    },
    primary: {
      type: "color",
      value: {
        dark: gray.variables["12"].value.dark,
        light: gray.variables["12"].value.light,
      },
    },
    promotional: {
      type: "color",
      value: {
        dark: cyan.variables["11"].value.dark,
        light: cyan.variables["11"].value.light,
      },
    },
    secondary: {
      type: "color",
      value: {
        dark: gray.variables["10"].value.dark,
        light: gray.variables["10"].value.light,
      },
    },
    success: {
      type: "color",
      value: {
        dark: grass.variables["11"].value.dark,
        light: grass.variables["11"].value.light,
      },
    },
    warning: {
      type: "color",
      value: {
        dark: amber.variables["11"].value.dark,
        light: amber.variables["11"].value.light,
      },
    },
  },
} as const satisfies TokenGroup<"text">;
